
import React from 'react'
import ExcelUpload from '../../components/common/excel-upload/excel-upload'

const PDIExcelCikisIptal = () => {
    return (
        <div>
            <ExcelUpload
                requiredColumnsSase={["sase"]}
                process_type="PDI_EXIT_CANCEL"
                ExcelName={"PDI Çıkış İptal Hatalı Şaseler"}
                Title={"PDI Çıkış İptal"}
                exampleData={[
                    { sase: "VF3YEF6F0RMA03711" },
                ]}
                role_name={"pdiexcel_cikis_read"}
            />
        </div>
    )
}

export default PDIExcelCikisIptal